import Board from './components/board';
import './App.css';
import Control from './components/control';

function App() {
  return (
    <div className="App">
      <Board />
      <Control />
    </div>
  );
}

export default App;
